import  React, { useState } from 'react'
import './Styles/LoginRegister.css'
import regImage from '../Components/Assets/register-page-left.jpg'
import { Link } from 'react-router-dom';

const LoginRegister = () => {

  const [isLogin, setIsLogin] = useState("Login");
  const [loading, setLoading]     = useState(false)
  const [error,   setError]       = useState('')
  const [showPass, setShowPass]   = useState(false)
  const [agreed,  setAgreed]      = useState(false)

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: ""
  });

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
    setError('');
  };

  const switchMode = (toLogin) => {
    setIsLogin(toLogin)
    setError('')
    setFormData({ username: '', email: '', password: '' })
    setShowPass(false)
    setAgreed(false)
  }

  const handleSubmit = async () => {
    // Basic validation
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields.')
      return
    }
    if (!isLogin && !formData.username) {
      setError('Please enter your name.')
      return
    }
    if (!isLogin && !agreed) {
      setError('Please agree to the Terms and Conditions.')
      return
    }

    setLoading(true)
    setError('')

    const endpoint = isLogin ? `${process.env.REACT_APP_API_URL}/login` : `${process.env.REACT_APP_API_URL}/register`

    try {
      const res  = await fetch(endpoint, {
        method:  'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body:    JSON.stringify(formData)
      })
      const data = await res.json()

      if (data.success) {
        localStorage.setItem('auth-token', data.authToken)
        localStorage.setItem('username', data.username)
        window.location.replace('/')
      } else {
        setError(data.error || 'Something went wrong. Please try again.')
      }
    } catch {
      setError('Unable to connect. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSubmit()
  }

  return (
    <div className="lr-page">
      <div className="lr-container">

        {/* ── Left: image ── */}
        <div className="lr-left">
          <img src={regImage} alt="JENITAS Fashion" />
        </div>

        {/* right side form */}
        <div className="lr-right">

          {/* Brand accent bar at top */}
          <div className="lr-accent-bar" />

          <div className="lr-form-wrap">
            <h1 className="lr-title">
              {isLogin ? 'Welcome back' : 'Create account'}
            </h1>
            <p className="lr-subtitle">
              {isLogin
                ? 'Sign in to your JENITAS account'
                : 'Join JENITAS and start shopping'}
            </p>

            {/* Error message */}
            {error && (
              <div className="lr-error">{error}</div>
            )}

            <div className="lr-fields">
              {!isLogin && (
                <div className="lr-field">
                  <label>Full Name</label>
                  <input
                      type="text"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Your name"
                      autoComplete="name"
                  />
                </div>
              )}

              <div className="lr-field">
                <label>Email Address</label>
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    placeholder="you@example.com"
                    autoComplete="email"
                />
              </div>
              <div className="lr-field">
                <label>Password</label>
                <div className="lr-password-wrap">
                  <input
                      type={showPass ? 'text' : 'password'}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      placeholder="••••••••"
                      autoComplete={isLogin ? 'current-password' : 'new-password'}
                  />
                  <button
                      type="button"
                      className="lr-eye-btn"
                      onClick={() => setShowPass(p => !p)}
                      tabIndex={-1}
                      aria-label={showPass ? 'Hide password' : 'Show password'} 
                  >
                    {showPass ? (
                        // Eye-off icon
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
                            <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
                            <line x1="1" y1="1" x2="23" y2="23"/>
                        </svg>
                    ) : (
                        // Eye icon
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                            <circle cx="12" cy="12" r="3"/>
                        </svg>
                    )}
                  </button>
                </div>
              </div>

            </div>

            {/* Terms for register */}
            {!isLogin && (
              <label className="lr-terms">
                <input
                    type="checkbox"
                    checked={agreed}
                    onChange={e => setAgreed(e.target.checked)}
                />
                <span>I agree to the <span className="lr-terms-link"><Link to="/terms-and-conditions">Terms and Conditions</Link></span></span>
              </label>
            )}

            {/* Submit button */}
            <button
              className="lr-submit-btn"
              onClick={handleSubmit}
              disabled={loading} >
                {loading
                    ? (isLogin ? 'Signing in...' : 'Creating account...')
                    : (isLogin ? 'Sign In' : 'Create Account')
                }
            </button>

            {/* Switch mode */}
            <p className="lr-switch">
              {isLogin ? "Don't have an account? " : 'Already have an account? '}
              <span onClick={() => switchMode(!isLogin)}>
                  {isLogin ? 'Register' : 'Sign in'}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginRegister